import { toURLSearchParams } from '@wix/metro-runtime';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveWixBookingsServicesV2ServicesServiceUrl(opts) {
    const domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-2',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-2',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/** Creates a new service. */
export function createService(payload) {
    function __createService({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'service.createdDate' },
                    { path: 'service.updatedDate' },
                    { path: 'service.media.items.image.urlExpirationDate' },
                    { path: 'service.media.mainMedia.image.urlExpirationDate' },
                    { path: 'service.media.coverMedia.image.urlExpirationDate' },
                    { path: 'service.bookingPolicy.createdDate' },
                    { path: 'service.bookingPolicy.updatedDate' },
                    { path: 'service.schedule.firstSessionStart' },
                    { path: 'service.schedule.lastSessionEnd' },
                    { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
                    {
                        path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                    },
                    { path: 'service.supportedSlugs.createdDate' },
                    { path: 'service.mainSlug.createdDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'service.locations.business.address.geocode.latitude' },
                    { path: 'service.locations.business.address.geocode.longitude' },
                    { path: 'service.locations.custom.address.geocode.latitude' },
                    { path: 'service.locations.custom.address.geocode.longitude' },
                    { path: 'service.locations.calculatedAddress.geocode.latitude' },
                    { path: 'service.locations.calculatedAddress.geocode.longitude' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CreateService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __createService;
}
/** Retrieves a service. */
export function getService(payload) {
    function __getService({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'GET',
            methodFqn: 'wix.bookings.services.v2.ServicesService.GetService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: payload,
                host,
            }),
            params: toURLSearchParams(payload),
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __getService;
}
/**
 * Updates a service.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time the service is updated, `revision` increments by 1. You must
 * include the number of the existing revision when updating the service.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 */
export function updateService(payload) {
    function __updateService({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKFieldMaskToRESTFieldMask,
                paths: [{ path: 'mask' }],
            },
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'service.createdDate' },
                    { path: 'service.updatedDate' },
                    { path: 'service.media.items.image.urlExpirationDate' },
                    { path: 'service.media.mainMedia.image.urlExpirationDate' },
                    { path: 'service.media.coverMedia.image.urlExpirationDate' },
                    { path: 'service.bookingPolicy.createdDate' },
                    { path: 'service.bookingPolicy.updatedDate' },
                    { path: 'service.schedule.firstSessionStart' },
                    { path: 'service.schedule.lastSessionEnd' },
                    { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
                    {
                        path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                    },
                    { path: 'service.supportedSlugs.createdDate' },
                    { path: 'service.mainSlug.createdDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'service.locations.business.address.geocode.latitude' },
                    { path: 'service.locations.business.address.geocode.longitude' },
                    { path: 'service.locations.custom.address.geocode.latitude' },
                    { path: 'service.locations.custom.address.geocode.longitude' },
                    { path: 'service.locations.calculatedAddress.geocode.latitude' },
                    { path: 'service.locations.calculatedAddress.geocode.longitude' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'PATCH',
            methodFqn: 'wix.bookings.services.v2.ServicesService.UpdateService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{service.id}',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __updateService;
}
/**
 * Updates multiple services.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1. You must
 * include the number of the existing revision for each service to update.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 */
export function bulkUpdateServices(payload) {
    function __bulkUpdateServices({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKFieldMaskToRESTFieldMask,
                paths: [{ path: 'services.mask' }],
            },
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'services.service.createdDate' },
                    { path: 'services.service.updatedDate' },
                    { path: 'services.service.media.items.image.urlExpirationDate' },
                    { path: 'services.service.media.mainMedia.image.urlExpirationDate' },
                    { path: 'services.service.media.coverMedia.image.urlExpirationDate' },
                    { path: 'services.service.bookingPolicy.createdDate' },
                    { path: 'services.service.bookingPolicy.updatedDate' },
                    { path: 'services.service.schedule.firstSessionStart' },
                    { path: 'services.service.schedule.lastSessionEnd' },
                    {
                        path: 'services.service.staffMembers.mainMedia.image.urlExpirationDate',
                    },
                    {
                        path: 'services.service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                    },
                    { path: 'services.service.supportedSlugs.createdDate' },
                    { path: 'services.service.mainSlug.createdDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    {
                        path: 'services.service.locations.business.address.geocode.latitude',
                    },
                    {
                        path: 'services.service.locations.business.address.geocode.longitude',
                    },
                    {
                        path: 'services.service.locations.custom.address.geocode.latitude',
                    },
                    {
                        path: 'services.service.locations.custom.address.geocode.longitude',
                    },
                    {
                        path: 'services.service.locations.calculatedAddress.geocode.latitude',
                    },
                    {
                        path: 'services.service.locations.calculatedAddress.geocode.longitude',
                    },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'results.item.createdDate' },
                        { path: 'results.item.updatedDate' },
                        { path: 'results.item.media.items.image.urlExpirationDate' },
                        { path: 'results.item.media.mainMedia.image.urlExpirationDate' },
                        { path: 'results.item.media.coverMedia.image.urlExpirationDate' },
                        { path: 'results.item.bookingPolicy.createdDate' },
                        { path: 'results.item.bookingPolicy.updatedDate' },
                        { path: 'results.item.schedule.firstSessionStart' },
                        { path: 'results.item.schedule.lastSessionEnd' },
                        {
                            path: 'results.item.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'results.item.supportedSlugs.createdDate' },
                        { path: 'results.item.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'results.item.locations.business.address.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.business.address.geocode.longitude',
                        },
                        {
                            path: 'results.item.locations.custom.address.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.custom.address.geocode.longitude',
                        },
                        {
                            path: 'results.item.locations.calculatedAddress.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.calculatedAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bulkUpdateServices;
}
/**
 * Updates multiple services by filter.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1.
 */
export function bulkUpdateServicesByFilter(payload) {
    function __bulkUpdateServicesByFilter({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKFieldMaskToRESTFieldMask,
                paths: [{ path: 'mask' }],
            },
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'service.createdDate' },
                    { path: 'service.updatedDate' },
                    { path: 'service.media.items.image.urlExpirationDate' },
                    { path: 'service.media.mainMedia.image.urlExpirationDate' },
                    { path: 'service.media.coverMedia.image.urlExpirationDate' },
                    { path: 'service.bookingPolicy.createdDate' },
                    { path: 'service.bookingPolicy.updatedDate' },
                    { path: 'service.schedule.firstSessionStart' },
                    { path: 'service.schedule.lastSessionEnd' },
                    { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
                    {
                        path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                    },
                    { path: 'service.supportedSlugs.createdDate' },
                    { path: 'service.mainSlug.createdDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'service.locations.business.address.geocode.latitude' },
                    { path: 'service.locations.business.address.geocode.longitude' },
                    { path: 'service.locations.custom.address.geocode.latitude' },
                    { path: 'service.locations.custom.address.geocode.longitude' },
                    { path: 'service.locations.calculatedAddress.geocode.latitude' },
                    { path: 'service.locations.calculatedAddress.geocode.longitude' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServicesByFilter',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update-by-filter',
                data: serializedData,
                host,
            }),
            data: serializedData,
        };
        return metadata;
    }
    return __bulkUpdateServicesByFilter;
}
/** Deletes a service. */
export function deleteService(payload) {
    function __deleteService({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'DELETE',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DeleteService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: payload,
                host,
            }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __deleteService;
}
/** Deletes multiple services. */
export function bulkDeleteServices(payload) {
    function __bulkDeleteServices({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'results.item.createdDate' },
                        { path: 'results.item.updatedDate' },
                        { path: 'results.item.media.items.image.urlExpirationDate' },
                        { path: 'results.item.media.mainMedia.image.urlExpirationDate' },
                        { path: 'results.item.media.coverMedia.image.urlExpirationDate' },
                        { path: 'results.item.bookingPolicy.createdDate' },
                        { path: 'results.item.bookingPolicy.updatedDate' },
                        { path: 'results.item.schedule.firstSessionStart' },
                        { path: 'results.item.schedule.lastSessionEnd' },
                        {
                            path: 'results.item.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'results.item.supportedSlugs.createdDate' },
                        { path: 'results.item.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'results.item.locations.business.address.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.business.address.geocode.longitude',
                        },
                        {
                            path: 'results.item.locations.custom.address.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.custom.address.geocode.longitude',
                        },
                        {
                            path: 'results.item.locations.calculatedAddress.geocode.latitude',
                        },
                        {
                            path: 'results.item.locations.calculatedAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bulkDeleteServices;
}
/** Deletes multiple services by filter. */
export function bulkDeleteServicesByFilter(payload) {
    function __bulkDeleteServicesByFilter({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServicesByFilter',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete-by-filter',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __bulkDeleteServicesByFilter;
}
/**
 * Retrieves a list of up to 100 services, given the provided paging, filtering, and sorting.
 * `queryServices()` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter is defined more than once in a query, only the first occurrence is processed.
 */
export function queryServices(payload) {
    function __queryServices({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/query',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'services.createdDate' },
                        { path: 'services.updatedDate' },
                        { path: 'services.media.items.image.urlExpirationDate' },
                        { path: 'services.media.mainMedia.image.urlExpirationDate' },
                        { path: 'services.media.coverMedia.image.urlExpirationDate' },
                        { path: 'services.bookingPolicy.createdDate' },
                        { path: 'services.bookingPolicy.updatedDate' },
                        { path: 'services.schedule.firstSessionStart' },
                        { path: 'services.schedule.lastSessionEnd' },
                        {
                            path: 'services.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'services.supportedSlugs.createdDate' },
                        { path: 'services.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'services.locations.business.address.geocode.latitude' },
                        { path: 'services.locations.business.address.geocode.longitude' },
                        { path: 'services.locations.custom.address.geocode.latitude' },
                        { path: 'services.locations.custom.address.geocode.longitude' },
                        { path: 'services.locations.calculatedAddress.geocode.latitude' },
                        {
                            path: 'services.locations.calculatedAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __queryServices;
}
/**
 * Retrieves a list of up to 100 services, given the provided query string,
 * and paging.
 */
export function searchServices(payload) {
    function __searchServices({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'search.aggregations.range.buckets.from' },
                    { path: 'search.aggregations.range.buckets.to' },
                    {
                        path: 'search.aggregations.nested.nestedAggregations.range.buckets.from',
                    },
                    {
                        path: 'search.aggregations.nested.nestedAggregations.range.buckets.to',
                    },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SearchServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/search',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'services.createdDate' },
                        { path: 'services.updatedDate' },
                        { path: 'services.media.items.image.urlExpirationDate' },
                        { path: 'services.media.mainMedia.image.urlExpirationDate' },
                        { path: 'services.media.coverMedia.image.urlExpirationDate' },
                        { path: 'services.bookingPolicy.createdDate' },
                        { path: 'services.bookingPolicy.updatedDate' },
                        { path: 'services.schedule.firstSessionStart' },
                        { path: 'services.schedule.lastSessionEnd' },
                        {
                            path: 'services.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'services.supportedSlugs.createdDate' },
                        { path: 'services.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'services.locations.business.address.geocode.latitude' },
                        { path: 'services.locations.business.address.geocode.longitude' },
                        { path: 'services.locations.custom.address.geocode.latitude' },
                        { path: 'services.locations.custom.address.geocode.longitude' },
                        { path: 'services.locations.calculatedAddress.geocode.latitude' },
                        {
                            path: 'services.locations.calculatedAddress.geocode.longitude',
                        },
                        { path: 'aggregationData.results.ranges.results.from' },
                        { path: 'aggregationData.results.ranges.results.to' },
                        {
                            path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.from',
                        },
                        {
                            path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.to',
                        },
                        {
                            path: 'aggregationData.results.nested.results.results.range.from',
                        },
                        {
                            path: 'aggregationData.results.nested.results.results.range.to',
                        },
                        { path: 'aggregationData.results.scalar.value' },
                        {
                            path: 'aggregationData.results.groupedByValue.results.nestedResults.scalar.value',
                        },
                        {
                            path: 'aggregationData.results.nested.results.results.scalar.value',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __searchServices;
}
/**
 * Retrieves a list of up to 100 policies, given the provided paging,
 * filtering, and sorting.
 *
 *
 * Define queries using [WQL - Wix Query
 * Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * For field support for filters and sorting, see [Supported Filters and
 * Sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/supported-filters-and-sorting).
 *
 * To retrieve all policies use an empty query:
 *
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 * `Query Policies` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter
 * is defined more than once in a query, only the first occurrence is
 * processed.
 */
export function queryPolicies(payload) {
    function __queryPolicies({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryPolicies',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/policies/query',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'bookingPolicies.bookingPolicy.createdDate' },
                        { path: 'bookingPolicies.bookingPolicy.updatedDate' },
                        { path: 'bookingPolicies.services.createdDate' },
                        { path: 'bookingPolicies.services.updatedDate' },
                        {
                            path: 'bookingPolicies.services.media.items.image.urlExpirationDate',
                        },
                        {
                            path: 'bookingPolicies.services.media.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'bookingPolicies.services.media.coverMedia.image.urlExpirationDate',
                        },
                        { path: 'bookingPolicies.services.bookingPolicy.createdDate' },
                        { path: 'bookingPolicies.services.bookingPolicy.updatedDate' },
                        { path: 'bookingPolicies.services.schedule.firstSessionStart' },
                        { path: 'bookingPolicies.services.schedule.lastSessionEnd' },
                        {
                            path: 'bookingPolicies.services.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'bookingPolicies.services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'bookingPolicies.services.supportedSlugs.createdDate' },
                        { path: 'bookingPolicies.services.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'bookingPolicies.services.locations.business.address.geocode.latitude',
                        },
                        {
                            path: 'bookingPolicies.services.locations.business.address.geocode.longitude',
                        },
                        {
                            path: 'bookingPolicies.services.locations.custom.address.geocode.latitude',
                        },
                        {
                            path: 'bookingPolicies.services.locations.custom.address.geocode.longitude',
                        },
                        {
                            path: 'bookingPolicies.services.locations.calculatedAddress.geocode.latitude',
                        },
                        {
                            path: 'bookingPolicies.services.locations.calculatedAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __queryPolicies;
}
/** Retrieves the number of services that match the provided filters. */
export function countServices(payload) {
    function __countServices({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CountServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/count',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __countServices;
}
/** Query locations that exist on services. */
export function queryLocations(payload) {
    function __queryLocations({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryLocations',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/locations/query',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'businessLocations.locations.business.address.geocode.latitude',
                        },
                        {
                            path: 'businessLocations.locations.business.address.geocode.longitude',
                        },
                        {
                            path: 'businessLocations.locations.custom.address.geocode.latitude',
                        },
                        {
                            path: 'businessLocations.locations.custom.address.geocode.longitude',
                        },
                        {
                            path: 'businessLocations.locations.calculatedAddress.geocode.latitude',
                        },
                        {
                            path: 'businessLocations.locations.calculatedAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __queryLocations;
}
/** Query categories that exist on services. */
export function queryCategories(payload) {
    function __queryCategories({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryCategories',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/categories/query',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __queryCategories;
}
/**
 * Change the locations this service is offered at.
 * Changing locations may have impact on existing sessions and their
 * participants. When removing locations from a service, this endpoint
 * requires stating what to do with existing sessions occurring at the removed
 * locations.
 */
export function setServiceLocations(payload) {
    function __setServiceLocations({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'locations.business.address.geocode.latitude' },
                    { path: 'locations.business.address.geocode.longitude' },
                    { path: 'locations.custom.address.geocode.latitude' },
                    { path: 'locations.custom.address.geocode.longitude' },
                    { path: 'locations.calculatedAddress.geocode.latitude' },
                    { path: 'locations.calculatedAddress.geocode.longitude' },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.business.address.geocode.latitude',
                    },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.business.address.geocode.longitude',
                    },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.custom.address.geocode.latitude',
                    },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.custom.address.geocode.longitude',
                    },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.calculatedAddress.geocode.latitude',
                    },
                    {
                        path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.calculatedAddress.geocode.longitude',
                    },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetServiceLocations',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/locations',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __setServiceLocations;
}
/**
 * Enables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. This API enables customers to pay for the
 * service using one of the specified pricing plans.
 */
export function enablePricingPlansForService(payload) {
    function __enablePricingPlansForService({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.EnablePricingPlansForService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/add',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __enablePricingPlansForService;
}
/**
 * Disables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. Customers can't pay for the service using
 * a removed pricing plan. Existing payments with a removed plan aren't
 * affected.
 */
export function disablePricingPlansForService(payload) {
    function __disablePricingPlansForService({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DisablePricingPlansForService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/remove',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __disablePricingPlansForService;
}
/**
 * Sets a custom (user-defined) slug for the various service pages.
 * The call may fail if there's another service with the same slug, either by
 * past name or by a custom slug.
 */
export function setCustomSlug(payload) {
    function __setCustomSlug({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetCustomSlug',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/slugs/custom',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'slug.createdDate' },
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __setCustomSlug;
}
/**
 * Validate a custom (user-defined) slug, making sure no other service uses
 * the same slug. The call may fail if there's another service with the same
 * slug, either by past name or by a custom set slug.
 */
export function validateSlug(payload) {
    function __validateSlug({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.ValidateSlug',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/slugs/validate',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __validateSlug;
}
/** Clones a service. */
export function cloneService(payload) {
    function __cloneService({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CloneService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/clone',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'service.createdDate' },
                        { path: 'service.updatedDate' },
                        { path: 'service.media.items.image.urlExpirationDate' },
                        { path: 'service.media.mainMedia.image.urlExpirationDate' },
                        { path: 'service.media.coverMedia.image.urlExpirationDate' },
                        { path: 'service.bookingPolicy.createdDate' },
                        { path: 'service.bookingPolicy.updatedDate' },
                        { path: 'service.schedule.firstSessionStart' },
                        { path: 'service.schedule.lastSessionEnd' },
                        {
                            path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        {
                            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
                        },
                        { path: 'service.supportedSlugs.createdDate' },
                        { path: 'service.mainSlug.createdDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'service.locations.business.address.geocode.latitude' },
                        { path: 'service.locations.business.address.geocode.longitude' },
                        { path: 'service.locations.custom.address.geocode.latitude' },
                        { path: 'service.locations.custom.address.geocode.longitude' },
                        { path: 'service.locations.calculatedAddress.geocode.latitude' },
                        { path: 'service.locations.calculatedAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __cloneService;
}
//# sourceMappingURL=bookings-services-v2-service-services.http.js.map